module.exports = __webpack_public_path__ + "static/netflix-estacao-2-9a75eb1f75338f97ededff18cd6650b5.jpg";